if (!customElements.get('ginza-color-selector')) {
  customElements.define(
    'ginza-color-selector',
    class GinzaColorSelector extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!this.dataset.productTags.includes('colori-ginza')) return;

        this.productId = this.dataset.productId;
        this.storageKey = `ginza-color-selection-${this.productId}`;
        
        this.colorTableUrl = this.dataset.colorTableUrl;
        this.assetBaseUrl = this.colorTableUrl.substring(0, this.colorTableUrl.lastIndexOf('/') + 1);
        this.colorData = null;
        this.currentTonalita = null;

        // Elementi UI
        this.inputGroup = this.querySelector('.ginza-input-group');
        this.colorInputDisplay = this.querySelector('.ginza-color-display');
        this.colorInputReal = this.querySelector('.ginza-color-real');
        this.selectedPreviewContainer = this.querySelector('.ginza-selected-preview');
        this.toggleBtn = this.querySelector('.ginza-toggle-btn');
        this.clearBtn = this.querySelector('.ginza-clear-btn');
        
        // Elementi Modale
        this.modalOverlay = this.querySelector('.ginza-modal-overlay');
        this.modalCloseBtn = this.querySelector('.ginza-modal-close');
        this.modalVariantName = this.querySelector('.ginza-modal-variant-name');
        this.colorSwatchContainer = this.querySelector('.color-swatch-container');

        this.initialize();
      }

      disconnectedCallback() {
        document.removeEventListener('ginza:variant-change', this.handleVariantChange);
      }

      async initialize() {
        this.setupEventListeners();
        
        // Forza un controllo iniziale dopo un breve ritardo
        setTimeout(() => {
            const variantSelector = document.getElementById(this.closest('section').querySelector('.product-variant-selects').id);
            if (variantSelector) {
                const selectedElements = variantSelector.querySelectorAll('input:checked, option:checked');
                const values = Array.from(selectedElements).map(el => el.value).join(' ');
                this.handleVariantChange({ detail: { variantValue: values } });
            } else {
                this.updateToggleButton();
            }
        }, 100);

        try {
          await this.fetchColorData();
          
          // ORA che abbiamo i dati, possiamo ripristinare la selezione e renderizzare
          this.restoreSelection();
          
          if (this.currentTonalita) {
            this.renderColorSwatches();
          }
        } catch (error) {
          console.error('Ginza Color Selector: Initialization failed', error);
          if (this.toggleBtn) this.toggleBtn.textContent = 'Errore nel caricamento dati';
        }
      }

      async fetchColorData() {
        if (this.colorData) return;
        try {
          const response = await fetch(this.colorTableUrl);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          this.colorData = await response.json();
        } catch (error) {
          console.error('Error fetching color data:', error);
          throw error;
        }
      }

      setupEventListeners() {
        this.handleVariantChange = this.handleVariantChange.bind(this);
        document.addEventListener('ginza:variant-change', this.handleVariantChange);

        this.toggleBtn.addEventListener('click', () => this.openModal());
        this.modalCloseBtn.addEventListener('click', () => this.closeModal());
        this.modalOverlay.addEventListener('click', (event) => {
          if (event.target === this.modalOverlay) this.closeModal();
        });

        this.clearBtn.addEventListener('click', () => this.clearSelection());

        this.colorSwatchContainer.addEventListener('click', (event) => {
          const swatch = event.target.closest('.color-swatch');
          if (swatch) {
            this.updateSelection(swatch.dataset.colorName);
            this.closeModal();
          }
        });
      }

      handleVariantChange(event) {
        const variantValue = event.detail.variantValue.toUpperCase();
        let newTonalita = null;
        
        if (variantValue.includes('ORO')) newTonalita = 'ORO';
        else if (variantValue.includes('ARGENTO')) newTonalita = 'ARGENTO';
        
        if (newTonalita !== this.currentTonalita) {
          this.currentTonalita = newTonalita;
          // Se cambia la tonalità, resettiamo la selezione perché il colore potrebbe non essere valido per la nuova finitura
          // Ma non lo facciamo all'inizializzazione se c'è già una selezione valida salvata
          const savedColor = sessionStorage.getItem(this.storageKey);
          if (!savedColor) {
             this.clearSelection();
          }
          
          this.updateToggleButton();
          this.renderColorSwatches();
        }
      }
      
      updateSelection(colorName) {
        this.colorInputReal.value = colorName;
        sessionStorage.setItem(this.storageKey, colorName);
        this.renderSelectedPreview(colorName);
      }

      clearSelection() {
        this.colorInputReal.value = '';
        sessionStorage.removeItem(this.storageKey);
        this.selectedPreviewContainer.innerHTML = '';
        this.inputGroup.classList.remove('has-selection');
      }

      restoreSelection() {
        const savedColor = sessionStorage.getItem(this.storageKey);
        if (savedColor) {
          // Verifica se il colore salvato è valido per la tonalità corrente (se impostata)
          // O semplicemente prova a renderizzarlo se i dati sono caricati
          if (this.colorData) {
             this.updateSelection(savedColor);
          }
        }
      }

      renderSelectedPreview(colorName) {
        if (!this.colorData) return;
        
        const color = this.colorData.colori.find(c => c.codice === colorName);
        
        if (!color) {
            console.warn(`Colore ${colorName} non trovato nei dati.`);
            this.clearSelection();
            return;
        }

        const imageUrl = this.assetBaseUrl + color.path;

        this.inputGroup.classList.add('has-selection');
        this.selectedPreviewContainer.innerHTML = `
            <div class="color-swatch" style="background-image: url('${imageUrl}'); width: 100%; height: 100%; cursor: default;" title="${color.codice}">
                <div class="color-swatch-inner" style="width: 100%;">
                    ${color.codice}
                </div>
            </div>
        `;
      }

      updateToggleButton() {
        if (this.currentTonalita) {
          this.toggleBtn.textContent = `Mostra Tabella Colori ${this.currentTonalita}`;
          this.toggleBtn.disabled = false;
        } else {
          this.toggleBtn.textContent = 'Seleziona una finitura (Oro/Argento)';
          this.toggleBtn.disabled = true;
        }
      }

      openModal() {
        if (!this.currentTonalita || !this.modalOverlay) return;
        document.body.style.overflow = 'hidden';
        this.modalVariantName.textContent = this.currentTonalita;
        this.modalOverlay.classList.add('is-visible');
      }

      closeModal() {
        if (!this.modalOverlay) return;
        document.body.style.overflow = '';
        this.modalOverlay.classList.remove('is-visible');
      }

      renderColorSwatches() {
        if (!this.colorData || !this.colorSwatchContainer) return;
        
        if (!this.currentTonalita) {
            this.colorSwatchContainer.innerHTML = '';
            return;
        }

        const filteredColors = this.colorData.colori.filter(
          (color) => color.tonalita && color.tonalita.toUpperCase() === this.currentTonalita
        );

        this.colorSwatchContainer.innerHTML = '';

        if (filteredColors.length === 0) {
          this.colorSwatchContainer.innerHTML = '<p style="padding:10px; width:100%;">Nessun colore trovato per questa finitura.</p>';
          return;
        }

        filteredColors.forEach((color) => {
          const swatch = document.createElement('div');
          swatch.className = 'color-swatch';
          
          const imageUrl = this.assetBaseUrl + color.path;
          swatch.style.backgroundImage = `url('${imageUrl}')`;

          swatch.dataset.colorName = color.codice;
          swatch.title = `${color.codice}`;

          const swatchInner = document.createElement('div');
          swatchInner.className = 'color-swatch-inner';
          swatchInner.innerHTML = `
            ${color.codice}
          `;
          swatch.appendChild(swatchInner);

          this.colorSwatchContainer.appendChild(swatch);
        });
      }
    }
  );
}
